export const SURVEY_QUESTION_TYPE = {
    MULTIPLE_CHOICE: 'multiple_choice',
    TEXT: 'text',
    SELECT_ALL: 'select_all',
    RATING: 'rating'
}